<template>
 
<ui-button-options v-on:click.native.stop="()=>{}" :title="item.datetime" :subtitle="item.pushnote">
      <div slot="left"><ui-icon color="#B4B4B4" backgroundColor="transparent" class="email-icon" icon="dot-circle"></ui-icon></div>
     
     
      <div slot="options" v-if="computeUserAccess">
        <!--
          <ui-option title="language.edit" v-on:click.native.stop.prevent="editItem()" backgroundColor="#F2BC55" color="#FFFFFF" icon="pencil-alt"/>
          <ui-option title="language.delete" v-on:click.native.stop.prevent="deleteItem()" backgroundColor="#F46767" color="#FFFFFF" icon="times"/>
        -->
      </div>
      <!-- makes chevron disappear -->
      <div slot="right"></div>
    
   </ui-button-options>
</template>

<script>
import UiButtonOptions from '../UiButtonOptions.vue';
//import UiOption from '../UiOption.vue';
import UiIcon from '../UiIcon.vue';
//import { USER_LEVEL } from '../../settings/USER_LEVEL.js';
import { mapState } from 'vuex';
import { helper } from '../../services/Helper.js';

    
export default {
  name: 'button-pushnote',
  props:{
    item:{default:{id:0}},
    download_id:{default:0},
  },
  data:function(){
    return {
    }
  },
  computed:{
    ...mapState([
       'appSettings','group'
      ]),
    computeUserAccess(){
        return false;
        /*
        var isInGlobal=(this.$router.currentRoute.path=='/documents');
        if(!this.group.authorized && !isInGlobal ){
          // if we are in a group
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
         */
    }
  },
  methods:{
    createIntroText(txt){
         return helper.getExcerpt(txt);
    },
    viewPdf(url){
      this.$store.dispatch('open_pdf',{link:url,fileName:this.item.title,mimetype:"application/pdf"})
    },
    editItem(){
      
      this.$router.push({path:'/documents/'+this.item.id+'/update_item/'})
    
    },
    deleteItem(){
  
     var payload={
        id:this.item.id,
        store_key:this.download_id+"documents",
      }
      this.$store.dispatch('delete_pdf',payload);
   
     
    },
  },
  mounted:function(){
    
  },
  components:{
    UiButtonOptions,
    //UiOption,
    UiIcon,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img-icon{
  display:block;
  height: 50px;
  width: 50px;
  border-radius: 9999px;
  border: 1px solid #707070;
}
</style>
